import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LOGO_ICON = "https://customer-assets.emergentagent.com/job_prodimmo-media/artifacts/rb17en5i_logo_prodimmo-removebg-preview.png";

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 600);
    const t2 = setTimeout(() => setPhase(2), 1600);
    const t3 = setTimeout(() => setPhase(3), 2600);
    const t4 = setTimeout(() => onComplete(), 3200);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase < 3 && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[200] bg-[#0F172A] flex items-center justify-center"
          data-testid="splash-screen"
        >
          <div className="flex flex-col items-center">
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.1 }}
            >
              <img src={LOGO_ICON} alt="Prodimmo" className="w-20 h-20 md:w-28 md:h-28" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={phase >= 1 ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="mt-6 overflow-hidden"
            >
              <h1
                className="text-3xl md:text-5xl font-bold text-white tracking-tight"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {"Prodimmo".split("").map((char, i) => (
                  <motion.span
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    animate={phase >= 1 ? { opacity: 1, y: 0 } : {}}
                    transition={{ delay: 0.05 * i, duration: 0.4 }}
                    className="inline-block"
                  >
                    {char}
                  </motion.span>
                ))}
              </h1>
            </motion.div>

            <motion.div
              initial={{ width: 0 }}
              animate={phase >= 1 ? { width: "120px" } : {}}
              transition={{ duration: 0.8, delay: 0.4, ease: "easeInOut" }}
              className="h-[2px] bg-[#73B5E2] mt-4 rounded-full"
            />

            <motion.p
              initial={{ opacity: 0 }}
              animate={phase >= 2 ? { opacity: 1 } : {}}
              transition={{ duration: 0.5 }}
              className="text-[#73B5E2] text-sm mt-4 tracking-[0.3em] uppercase"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              Production immobilière
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
